module.exports = __webpack_public_path__ + "static/media/imagem-pop-up-montraprimavera.518c607b.png";